var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589",
    transform: "translate(-669 -827)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(669 827)",
    fill: "#3c2f87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "attachment",
    d: "M4.671,7.525c-.108.2-.043.365.178.587l.205.205c.224.224.393.287.587.178a1,1,0,0,0,.227-.178L7.091,7.1c.229-.2.464-.116.686.105s.365.492.16.735L6.1,9.768a1.637,1.637,0,0,1-2.444,0,1.7,1.7,0,0,1,0-2.444L7.326,3.659a1.62,1.62,0,0,1,2.444,0,1.531,1.531,0,0,1,.2,2.241.634.634,0,0,0-.084.9l.2.2c.308.306.589.211.892-.1A3.169,3.169,0,0,0,6.307,2.64L2.642,6.306a3.169,3.169,0,1,0,4.482,4.482L8.956,8.955a2.1,2.1,0,0,0-.262-2.671,2.037,2.037,0,0,0-2.621-.208L4.85,7.3a1.023,1.023,0,0,0-.178.227Z",
    transform: "translate(674.285 832.287)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.61804195f35ae1e209a946d97d6e09e5.svg";
export { ForwardRef as ReactComponent };